export default "__VITE_ASSET__CzUjxISx__"